import { GeneralPage } from "@pages/profile/general";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/profile/general")({
	component: GeneralPage,
	staticData: {
		breadcrumbId: "page.profile.general.title",
		breadcrumbTitle: "General",
	},
});
